import React from "react";
import { Menu, MenuItem, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router";

export const NewTransactionMenu = ({
  menuEl,
  setMenuEl,
}: {
  menuEl: HTMLElement | null;
  setMenuEl: (menuEl: HTMLElement | null) => void;
}) => {
  const { t } = useTranslation();

  const handleCloseMenu = () => setMenuEl(null);

  return (
    <Menu
      id="new-transaction-menu"
      open={Boolean(menuEl)}
      anchorEl={menuEl}
      keepMounted
      onClose={handleCloseMenu}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <MenuItem
        component={RouterLink}
        data-testid="investment-create"
        to="/new-transaction-wizard"
      >
        <Typography variant="inherit">
          {t("investmentsPage.header.actions.create")}
        </Typography>
      </MenuItem>
      <MenuItem
        component={RouterLink}
        data-testid="upload-pdf"
        to="/investments/file-drop"
      >
        <Typography variant="inherit">
          {t("investmentsPage.header.actions.uploadPdf")}
        </Typography>
      </MenuItem>
      <MenuItem
        component={RouterLink}
        data-testid="upload-csv"
        to="/investments/csv-drop"
      >
        <Typography variant="inherit">
          {t("investmentsPage.header.actions.uploadCsv")}
        </Typography>
      </MenuItem>
    </Menu>
  );
};
